'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormControl = require('./FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _FormControl2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-form-control/build/index.js
// module id = 153
// module chunks = 0